import React from "react";
import EstadisticasCanal from "./EstadisticasCanal";
export default function EstadisticasPyme(){ return <EstadisticasCanal canal="pyme" />; }
